export enum ReservationVariant {
    RealTime = 'realtime',
    OnRequest = 'on-request',
}
